module.exports = __webpack_public_path__ + "img/Refresh - Gray - Selected.eb034c2f.png";